import { apiRequest } from "../../../services/api";
import { IResetPassword } from "../type/resetPasswordType";

export const resetPassword = async (token: string, data: IResetPassword) => {
  const response = await apiRequest<IResetPassword>(
    "POST",
    `/auth/reset-password?token=${token}`,
    {
      password: data.password,
    }
  );
  return response.data;
};
